import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getSplitOrderRate = {
  name: "getSplitOrderRate" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
